import React, { memo } from "react";
import PeriodCell from "../PeriodCell";
import styles from "./PeriodRow.module.css";

const PeriodRow = memo(({ period, days, logs, teachers, onCellClick }) => {
	return (
		<div className={styles.periodRow}>
			<div className={styles.periodLabel}>{period}</div>
			<div className={styles.dayCells}>
				{days.map((day) => {
					if (period > day.periodCount) return null;

					const periodLogs = logs.getLogsForPeriod(day.dateFormatted, period);

					return (
						<PeriodCell
							key={`${day.dateFormatted}-${period}`}
							day={day}
							period={period}
							logs={periodLogs}
							teachers={teachers}
							onClick={onCellClick}
						/>
					);
				})}
			</div>
		</div>
	);
});

export default PeriodRow;
